import Vue from 'vue'
import VueRouter from 'vue-router'

import index from '@/views/index'
import login from '@/views/login'
import register from '@/views/register'
// import editInfo from '@/views/editInfo'
import health from '@/views/health'
import loseWeight from '@/views/loseWeight'
import physique from '@/views/physique'
import editphysique from "@/views/editphysique";
import foods from "@/views/foods";
import sport from "@/views/sport";
import foodPlan from "@/views/foodPlan";



const originPush = VueRouter.prototype.push
VueRouter.prototype.push = function (location, resolve, reject) {
  if (reject && resolve) {
    originPush.call(this, location, resolve, reject)
  } else {
    originPush.call(this, location, () => { }, () => { })
  }
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: index,
    meta: {
      noToken: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    meta: {
      noToken: true
    }
  },
  {
    path: '/register',
    name: 'register',
    component: register,
    meta: {
      noToken: true
    }
  },
  {
    path: '/forget',
    name: 'forget',
    component: () => import('@/views/forget'),
    meta: {
      noToken: true
    }
  },
  {
    path: '/forgetNext',
    name: 'forgetNext',
    component: () => import('@/views/forgetNext'),
    meta: {
      noToken: true
    }
  },
  // {
  //   path:'/editinfo',
  //   component: editInfo
  // },
  {
    path: '/health',
    component: health,
    name: 'health'
  },
  {
    path: '/loseweight',
    component: loseWeight,
    name: 'loseWeight',
    // meta: { keepAlive: true }
  },
  {
    path: '/foodPlan',
    component: foodPlan,
    name: 'foodPlan',
  },
  {
    path: '/physique',
    component: physique,
    name: 'physique',
    // meta: { keepAlive : true}
  },
  {
    path: '/physique/edit',
    component: editphysique,
    name: 'editphysique'
  },
  {
    path: '/check',
    component: () => import('@/views/check'),
    name: 'myCheck'
  },
  {
    path: '/checkDetail',
    component: () => import('@/views/checkDetail'),
    name: 'checkDetail'
  },
  {
    path: '/myMessage',
    component: () => import('@/views/myMessage'),
    name: 'myMessage'
  },
  {
    path: '/foods',
    component: foods,
    name: 'foods'
  },
  {
    path: '/foodsList',
    component: () => import('@/views/foodsList'),
    name: 'foodsList'
  },
  {
    path: '/physique/foodsListChose',
    component: () => import('@/views/foodsListChose'),
    name: 'foodsListChose'
  },
  {
    path: '/editFoods',
    component: () => import('@/views/editfoods'),
    name: 'editFoods'
  },
  {
    path: '/sport',
    component: sport,
    name: 'sport'
  },
  {
    path: '/sportChose',
    component: () => import('@/views/sportChose'),
    name: 'sportChose'
  },
  {
    path: '/hasrecord',
    component: () => import('@/views/hasRecord'),
    name: 'hasrecord'
  },
  {
    path: '/editsports/',
    component: () => import('@/views/editsports'),
    name: 'editsports'
  },
  {
    path: '/sleep',
    component: () => import('@/views/sleep'),
    name: 'sleep'
  },
  {
    path: '/sleepEdit',
    component: () => import('@/views/sleepEdit'),
    name: 'sleepEdit'
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
